import { AppLogo } from '@/assets/icons/AppLogo';
import { GithubIcon } from '@/assets/icons/brand-mark-icons';
import { CalendlyIcon } from '@/assets/icons/calendly';
import { Icons } from '@/assets/icons/icons';

import { WIKI_PROVIDERS, type WikiProvider } from '../people-wiki.types';

/** The logo of an account's provider, on the account badges and in the picker that adds an account. */
export const ProviderIcon = ({ provider }: { provider: WikiProvider }) => {
  switch (provider) {
    case WIKI_PROVIDERS.slack:
      return <Icons.slack className="size-3 shrink-0" />;
    case WIKI_PROVIDERS.gmail:
      return <Icons.gmail className="size-3 shrink-0" />;
    case WIKI_PROVIDERS.littlebird:
      return <AppLogo size={12} customColor="currentColor" decorative />;
    case WIKI_PROVIDERS.linkedin:
      return <Icons.linkedin className="size-3 shrink-0" />;
    case WIKI_PROVIDERS.github:
      return <GithubIcon className="size-3 shrink-0" />;
    case WIKI_PROVIDERS.x:
      return <Icons.twitter className="size-3 shrink-0" />;
    case WIKI_PROVIDERS.calendly:
      return <CalendlyIcon className="size-3 shrink-0" />;
    case WIKI_PROVIDERS.website:
      return <Icons.globe className="size-3 shrink-0" />;
    case WIKI_PROVIDERS.email:
      return <Icons.mail className="size-3 shrink-0" />;
    case WIKI_PROVIDERS.phone:
      return <Icons.phone className="size-3 shrink-0" />;
  }
};
